
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/playground',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/playground/',
            getPage: () => import(
              /* webpackChunkName: "playground" */
              '/work/playground/_site_tmp/_playground.js'
            ),
            
            
          },{
            path: '/playground/directions/',
            getPage: () => import(
              /* webpackChunkName: "playground-directions" */
              '/work/playground/_site_tmp/_playground_directions.js'
            ),
            
            
          },{
            path: '/playground/geocoding-v6/',
            getPage: () => import(
              /* webpackChunkName: "playground-geocoding-v6" */
              '/work/playground/_site_tmp/_playground_geocoding-v6.js'
            ),
            
            
          },{
            path: '/playground/geocoding/',
            getPage: () => import(
              /* webpackChunkName: "playground-geocoding" */
              '/work/playground/_site_tmp/_playground_geocoding.js'
            ),
            
            
          },{
            path: '/playground/gl-js-usage/',
            getPage: () => import(
              /* webpackChunkName: "playground-gl-js-usage" */
              '/work/playground/_site_tmp/_playground_gl-js-usage.js'
            ),
            
            
          },{
            path: '/playground/isochrone/',
            getPage: () => import(
              /* webpackChunkName: "playground-isochrone" */
              '/work/playground/_site_tmp/_playground_isochrone.js'
            ),
            
            
          },{
            path: '/playground/offline-estimator/',
            getPage: () => import(
              /* webpackChunkName: "playground-offline-estimator" */
              '/work/playground/_site_tmp/_playground_offline-estimator.js'
            ),
            
            
          },{
            path: '/playground/search-box/',
            getPage: () => import(
              /* webpackChunkName: "playground-search-box" */
              '/work/playground/_site_tmp/_playground_search-box.js'
            ),
            
            
          },{
            path: '/playground/static/',
            getPage: () => import(
              /* webpackChunkName: "playground-static" */
              '/work/playground/_site_tmp/_playground_static.js'
            ),
            
            
          },{
            path: '/playground/tilequery/',
            getPage: () => import(
              /* webpackChunkName: "playground-tilequery" */
              '/work/playground/_site_tmp/_playground_tilequery.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };